<template>
    <div class="matchingInfo">
        <matching-container></matching-container>
    </div>
</template>
<script>
import MatchingContainer from '@/components/matching/MatchingInfo.vue'
export default {
  name: 'matchingInfo',
  components: {
    MatchingContainer
  }
}
</script>
<style lang="stylus">
.matchingInfo
  width 100%
  height 100%
  overflow-y auto
</style>
